import React from 'react';
import { motion } from 'framer-motion';
const team = [{
  name: 'Thessaly Voss',
  role: 'Chief Executive Officer',
  bio: 'Former ESA mission analyst with a lifelong obsession for making space accessible.',
  initials: 'TV'
}, {
  name: 'Caelum Raith',
  role: 'Chief Technology Officer',
  bio: "Built satellite tracking systems before building Starkeep's real-time engine.",
  initials: 'CR'
}, {
  name: 'Isolde Maren',
  role: 'Head of Design',
  bio: 'Believes the cosmos deserves interfaces as beautiful as the night sky itself.',
  initials: 'IM'
}, {
  name: 'Fenwick Solari',
  role: 'Lead Engineer',
  bio: 'Optimizes algorithms so your star map renders faster than light reaches your eye.',
  initials: 'FS'
}];
export function TeamSection() {
  return <section id="team" className="py-24 relative z-10 bg-slate-900/20" data-id="element-151">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-152">
        <div className="text-center mb-16" data-id="element-153">
          <h2 className="text-3xl md:text-5xl font-heading font-bold text-white mb-4" data-id="element-154">
            The Minds Behind the Stars
          </h2>
          <p className="text-slate-400" data-id="element-155">United by a passion for the cosmos.</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-156">
          {team.map((member, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="group p-6 rounded-2xl bg-slate-900/40 backdrop-blur-sm border border-slate-800 hover:border-cyan-500/30 text-center transition-all duration-300" data-id="element-157">
              <div className="w-24 h-24 mx-auto mb-6 rounded-full bg-slate-800 border-2 border-slate-700 group-hover:border-cyan-500/50 flex items-center justify-center shadow-[0_0_15px_rgba(0,0,0,0.3)] group-hover:shadow-[0_0_20px_rgba(6,182,212,0.2)] transition-all" data-id="element-158">
                <span className="text-2xl font-heading font-bold text-cyan-400" data-id="element-159">
                  {member.initials}
                </span>
              </div>

              <h3 className="text-lg font-bold text-white mb-1 group-hover:text-cyan-200 transition-colors" data-id="element-160">
                {member.name}
              </h3>
              <p className="text-cyan-500 text-sm font-medium mb-4 uppercase tracking-wide" data-id="element-161">
                {member.role}
              </p>
              <p className="text-slate-400 text-sm leading-relaxed" data-id="element-162">
                "{member.bio}"
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}